import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgShadowOnEventDirective, NgShadowOnMouseHoverDirective, NgGrowShadowOnEventDirective, NgGrowShadowOnMouseHoverDirective, NgGlowOnEventDirective, NgGlowOnMouseHoverDirective, NgFloatShadowOnEventDirective, NgFloatShadowOnMouseHoverDirective, NgDokaOnEventDirective, NgDokaOnMouseHoverDirective, NgStripeOnEventDirective, NgStripeOnMouseHoverDirective } from './shadows';


@NgModule({
	declarations: [
		NgShadowOnEventDirective,
		NgShadowOnMouseHoverDirective,
		NgGrowShadowOnEventDirective,
		NgGrowShadowOnMouseHoverDirective,
		NgGlowOnEventDirective,
		NgGlowOnMouseHoverDirective,
		NgFloatShadowOnEventDirective,
		NgFloatShadowOnMouseHoverDirective,
		NgDokaOnEventDirective,
		NgDokaOnMouseHoverDirective,
		NgStripeOnEventDirective,
		NgStripeOnMouseHoverDirective
	],
	imports: [
		CommonModule
	],
	exports: [
		NgShadowOnEventDirective,
		NgShadowOnMouseHoverDirective,
		NgGrowShadowOnEventDirective,
		NgGrowShadowOnMouseHoverDirective,
		NgGlowOnEventDirective,
		NgGlowOnMouseHoverDirective,
		NgFloatShadowOnEventDirective,
		NgFloatShadowOnMouseHoverDirective,
		NgDokaOnEventDirective,
		NgDokaOnMouseHoverDirective,
		NgStripeOnEventDirective,
		NgStripeOnMouseHoverDirective
	]
})
export class NgShadowAnimationModule { }
